(() => {
  if (window.__topAnnouncementBarInitialized) return;
  window.__topAnnouncementBarInitialized = true;

  const instances = new Map();

  class TopAnnouncementBarCountdown {
    constructor(element) {
      this.element = element;
      this.wrapper = element.querySelector('[data-countdown-wrapper]');
      this.value = element.querySelector('[data-countdown-value]');
      this.benefitsTrack = element.querySelector('[data-benefits-track]');
      this.benefitItems = this.benefitsTrack ? Array.from(this.benefitsTrack.querySelectorAll('[data-benefit-item]')) : [];
      this.mobileQuery = window.matchMedia('(max-width: 989px)');
      this.intervalId = null;
      this.benefitIntervalId = null;
      this.benefitRestartTimeoutId = null;
      this.currentBenefitIndex = this.benefitItems.length > 1 ? 1 : 0;
      this.handleViewportChange = () => this.updateBenefitCarousel();
      this.handleBenefitInteraction = () => this.restartBenefitCarousel();
    }

    start() {
      if (!this.wrapper || !this.value) {
        this.setupBenefitCarousel();
        return;
      }

      const enabled = this.element.dataset.countdownEnabled === 'true';
      const endString = this.element.dataset.countdownEnd || '';
      const endTime = this.parseEndTime(endString);

      if (!enabled || !endTime) {
        this.hideCountdown();
        this.setupBenefitCarousel();
        return;
      }

      this.endTime = endTime;
      this.update();
      this.intervalId = window.setInterval(() => this.update(), 1000);
      this.setupBenefitCarousel();
    }

    stop() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }

      this.stopBenefitCarousel();

      if (this.mobileQuery) {
        if (typeof this.mobileQuery.removeEventListener === 'function') {
          this.mobileQuery.removeEventListener('change', this.handleViewportChange);
        } else if (typeof this.mobileQuery.removeListener === 'function') {
          this.mobileQuery.removeListener(this.handleViewportChange);
        }
      }

      if (this.benefitsTrack) {
        this.benefitsTrack.removeEventListener('pointerdown', this.handleBenefitInteraction);
        this.benefitsTrack.removeEventListener('touchstart', this.handleBenefitInteraction);
      }
    }

    parseEndTime(value) {
      if (!value) return null;
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return null;
      return parsed;
    }

    hideCountdown() {
      this.wrapper.hidden = true;
    }

    update() {
      if (!this.endTime) {
        this.hideCountdown();
        this.stop();
        return;
      }

      const diff = this.endTime.getTime() - Date.now();
      if (diff <= 0) {
        this.hideCountdown();
        this.stop();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const hh = String(hours).padStart(2, '0');
      const mm = String(minutes).padStart(2, '0');
      const ss = String(seconds).padStart(2, '0');

      this.wrapper.hidden = false;
      this.value.textContent = `${hh}:${mm}:${ss}`;
    }

    setupBenefitCarousel() {
      if (!this.benefitsTrack || this.benefitItems.length <= 1) return;

      if (typeof this.mobileQuery.addEventListener === 'function') {
        this.mobileQuery.addEventListener('change', this.handleViewportChange);
      } else if (typeof this.mobileQuery.addListener === 'function') {
        this.mobileQuery.addListener(this.handleViewportChange);
      }

      this.benefitsTrack.addEventListener('pointerdown', this.handleBenefitInteraction);
      this.benefitsTrack.addEventListener('touchstart', this.handleBenefitInteraction, { passive: true });

      this.updateBenefitCarousel();
    }

    updateBenefitCarousel() {
      if (!this.benefitsTrack || this.benefitItems.length <= 1) return;

      if (!this.mobileQuery.matches) {
        this.stopBenefitCarousel();
        this.benefitsTrack.scrollLeft = 0;
        return;
      }

      this.goToBenefit(this.currentBenefitIndex, 'auto');
      this.startBenefitCarousel();
    }

    startBenefitCarousel() {
      this.stopBenefitCarousel();

      this.benefitIntervalId = window.setInterval(() => {
        this.currentBenefitIndex = (this.currentBenefitIndex + 1) % this.benefitItems.length;
        this.goToBenefit(this.currentBenefitIndex, 'smooth');
      }, 2800);
    }

    stopBenefitCarousel() {
      if (this.benefitIntervalId) {
        window.clearInterval(this.benefitIntervalId);
        this.benefitIntervalId = null;
      }

      if (this.benefitRestartTimeoutId) {
        window.clearTimeout(this.benefitRestartTimeoutId);
        this.benefitRestartTimeoutId = null;
      }
    }

    restartBenefitCarousel() {
      if (!this.mobileQuery.matches || this.benefitItems.length <= 1) return;
      this.stopBenefitCarousel();
      this.benefitRestartTimeoutId = window.setTimeout(() => this.startBenefitCarousel(), 3200);
    }

    goToBenefit(index, behavior = 'smooth') {
      if (!this.benefitsTrack) return;
      const safeIndex = Math.max(0, Math.min(index, this.benefitItems.length - 1));
      const nextOffset = this.benefitsTrack.clientWidth * safeIndex;
      this.benefitsTrack.scrollTo({ left: nextOffset, behavior });
    }
  }

  const init = (root = document) => {
    const bars = root.querySelectorAll('[data-top-announcement-bar]');
    bars.forEach((bar) => {
      if (instances.has(bar)) return;
      const instance = new TopAnnouncementBarCountdown(bar);
      instance.start();
      instances.set(bar, instance);
    });
  };

  const destroy = (root = document) => {
    const bars = root.querySelectorAll('[data-top-announcement-bar]');
    bars.forEach((bar) => {
      const instance = instances.get(bar);
      if (!instance) return;
      instance.stop();
      instances.delete(bar);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
